import { render } from "./EditPlan.vue?vue&type=template&id=080048f4"
import script from "./EditPlan.vue?vue&type=script&lang=js"
export * from "./EditPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__